import type { FaireProductEntity } from "../../entity_types/product";

export const p_xtsweuwr4s: FaireProductEntity = {
  token: "p_xtsweuwr4s",
  type: "product",
  name: "Eo Products - Shower Gel Soothing French Lavender - 16 Fl Oz",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl: "https://cdn.faire.com/fastly/030febf0194345c5c3b15536b941d4e7fc41c3f19ddd643ba270f9cd42407a95.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d954719145cfd8f91a66ccc1174aa4904934e53b76b2268e2b0573acc8e5f664.jpeg"
  ],
  priceDollars: 28.75,
  description: "Unwind and rejuvenate with the calming essence of pure lavender essential oil in this luxurious shower gel. Crafted from natural ingredients, this soothing formula is designed to cleanse and nourish your skin without harsh chemicals. Enjoy the benefits of a paraben-free, phthalate-free, and sulfate-free blend that respects your skin's health.\n\n * Rich in fig, hop, aloe vera, chamomile, calendula, and white tea extracts for a revitalized feel. \n * Free from synthetic fragrances, ensuring a pure and natural scent experience. \n * A generous 16 fl. oz. bottle for long-lasting indulgence. \n * Perfect for daily use, providing a spa-like experience in the comfort of your own shower. \nLet tranquility wash over you as this gentle shower gel transforms your bathing routine into a serene escape.",
  tags: [],
  msrpDollars: 35.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:56.349Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
